module.exports = __webpack_public_path__ + "img/coupon_check.86c97f0c.svg";